import DeviceTable from 'components/tables/data/device/DeviceTable';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import useDepartmentUiMode from 'model/useDepartmentUiMode';

/**
 * Page used to display devices.
 *
 */
export default function DevicesPage() {
  const { mode: departmentUiMode } = useDepartmentUiMode();
  const [searchParams, setSearchParams] = useSearchParams();

  const [initialFilters] = useState(() => {
    const filters: Record<string, any> = {};

    if (searchParams.has('organizationId')) {
      filters['organization.organizationId'] = {
        filterType: 'text',
        type: 'equals',
        filter: searchParams.get('organizationId'),
      };
    }

    if (searchParams.has('departmentId')) {
      filters['department.departmentId'] = {
        mode: departmentUiMode === 'legacy' ? 'exact' : 'subtree',
        filterType: 'text',
        type: 'equals',
        filter: searchParams.get('departmentId'),
      };
    }

    if (searchParams.has('deviceTypeId')) {
      filters['deviceType.deviceTypeId'] = {
        filterType: 'text',
        type: 'equals',
        filter: searchParams.get('deviceTypeId'),
      };
    }

    if (searchParams.has('faultType')) {
      filters.faultType = {
        filterType: 'text',
        type: 'equals',
        filter: searchParams.get('faultType'),
      };
    }

    if (searchParams.has('importId')) {
      filters.importId = {
        filterType: 'text',
        type: 'equals',
        filter: searchParams.get('importId'),
      };
    }

    if (searchParams.has('remoteSourceId')) {
      filters['remoteSource.remoteSourceId'] = {
        filterType: 'text',
        type: 'equals',
        filter: searchParams.get('remoteSourceId'),
      };
    }

    if (searchParams.has('parentDeviceId')) {
      filters['parentDevice.deviceId'] = {
        filterType: 'text',
        type: 'equals',
        filter: searchParams.get('parentDeviceId'),
      };
    }

    return filters;
  });

  useEffect(() => {
    setSearchParams(
      (params) => {
        params.delete('organizationId');
        params.delete('departmentId');
        params.delete('deviceTypeId');
        params.delete('faultType');
        params.delete('importId');
        params.delete('remoteSourceId');
        params.delete('parentDeviceId');
        return params;
      },
      { replace: true }
    );
  }, []);

  return (
    <DashboardLayout height="screen" breadcrumbs={[{ title: 'Zariadenia' }]}>
      <DeviceTable initialFilters={initialFilters} />
    </DashboardLayout>
  );
}
